import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/context/ThemeContext";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Cantieri from "@/pages/Cantieri";
import CantiereDetail from "@/pages/CantiereDetail";
import Transazioni from "@/pages/Transazioni";
import Analisi from "@/pages/Analisi";
import Archivio from "@/pages/Archivio";
import Scadenze from "@/pages/Scadenze";
import Rapportini from "@/pages/Rapportini";
import Presenze from "@/pages/Presenze";
import ModelloOrganizzativo from "@/pages/ModelloOrganizzativo";
import Fir from "@/pages/Fir";
import Documenti from "@/pages/Documenti";
import Utenti from "@/pages/Utenti";
import Cestino from "@/pages/Cestino";
import Cronologia from "@/pages/Cronologia";
import Impostazioni from "@/pages/Impostazioni";

function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/cantieri" element={<Cantieri />} />
        <Route path="/cantieri/:id" element={<CantiereDetail />} />
        <Route path="/rapportini" element={<Rapportini />} />
        <Route path="/presenze" element={<Presenze />} />
        <Route path="/modello-organizzativo" element={<ModelloOrganizzativo />} />
        <Route path="/fir" element={<Fir />} />
        <Route path="/documenti" element={<Documenti />} />
        <Route path="/transazioni" element={<Transazioni />} />
        <Route path="/analisi" element={<Analisi />} />
        <Route path="/archivio" element={<Archivio />} />
        <Route path="/scadenze" element={<Scadenze />} />
        <Route path="/utenti" element={<Utenti />} />
        <Route path="/cestino" element={<Cestino />} />
        <Route path="/cronologia" element={<Cronologia />} />
        <Route path="/impostazioni" element={<Impostazioni />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <BrowserRouter>
          <AuthProvider>
            <AppRouter />
            <Toaster position="top-right" richColors closeButton />
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
